import type { PasswordHelperRule } from '@sunwebgroup/uds-ui/fields/password-field'
import { PasswordField } from '@sunwebgroup/uds-ui/fields/password-field'
import { useFormContext } from 'react-hook-form'
import { useIntl } from '@/intl'
import { getErrorMessage } from '@/scopes/common/components/FormElements/getErrorMessage'
import { useStatus } from '@/scopes/common/components/FormElements/useStatus'

export interface PasswordInputProps {
  name: string
  label?: string
  required?: boolean
  disabled?: boolean
  requiredErrorMessage?: string
  showPasswordLabel?: string
  hidePasswordLabel?: string
  autoComplete?: string
  helperRules?: PasswordHelperRule[][]
  validations?: Record<string, (value: string) => boolean>
}

export function PasswordInput({
  name,
  label,
  required,
  requiredErrorMessage,
  showPasswordLabel,
  hidePasswordLabel,
  disabled,
  autoComplete,
  helperRules,
  validations,
}: PasswordInputProps) {
  const intl = useIntl()
  const {
    register,
    formState,
  } = useFormContext()

  const registration = register(name, { required, validate: validations })

  const { errors } = formState
  const status = useStatus({
    name,
    required,
    validations,
  })
  const errorMessage = getErrorMessage(
    name,
    errors,
    { requiredErrorMessage },
  )

  return (
    <PasswordField
      name={name}
      label={label}
      feedbackText={errorMessage}
      status={status}
      optionalLabel={!required ? intl.formatMessage({ id: 'common_form_field_optional_label' }) : undefined}
      showPasswordLabel={showPasswordLabel}
      hidePasswordLabel={hidePasswordLabel}
      helperRules={helperRules}
      inputProps={{ ...registration, autoComplete }}
      disabled={disabled}
    />
  )
}
